import React from 'react';
import {IDrawerContent} from './drawer.service.interface';

export class DrawerContentDecorator implements IDrawerContent {
    constructor(private readonly _originalDrawerContent: IDrawerContent, private readonly _id: string) {

    }

    get id(): string {
        if(this._originalDrawerContent.id) {
            return this._originalDrawerContent.id;
        }

        return this._id;
    }
    get isMinimized(): boolean {
        return this._originalDrawerContent.isMinimized;
    }

    onClose(): void {
        if(this._originalDrawerContent.onClose) {
            this._originalDrawerContent.onClose();
        }
    }

    render(): React.ReactNode {
        return this._originalDrawerContent.render();
    }

    get title(): string {
        return this._originalDrawerContent.title;
    }

    get minOverlayZIndex(): number | null {
        return this._originalDrawerContent.minOverlayZIndex;
    }

    get supportsCloseIntent(): boolean {
        return Boolean(this._originalDrawerContent.supportsCloseIntent);
    }

    onOverlayClicked(): void {
        if(this._originalDrawerContent.onOverlayClicked) {
            this._originalDrawerContent.onOverlayClicked();
        }
    }
}